// The Phase 1b cart was a localStorage stub used only by the header
// badge. Phase 2c moves the cart server-side (signed cookie for
// anonymous, user_id once signed in — see app/models/cart.rb). This
// file now exists only to expose `useCartCount()` for the header,
// backed by the new `useCart()` react-query hook.
//
// Pre-existing localStorage rows (key `jdr.cart.v1`) are abandoned on
// upgrade; the migration cost is acceptable pre-launch.

import { useCart } from "./hooks";

// Total quantity across all line items. The badge shows nothing when
// this is 0 (FR-13 of 1b: "Zero count → no badge").
export function useCartCount(): number {
  const { data } = useCart();
  return data?.payload?.items?.length ?? 0;
}
